import {byte, isDefined, panic} from "@opendaw/lib-std"
import {DrumKits, KitSample} from "./DrumKits"

export type Pad = {
    note: byte
    sample: KitSample
    // Choke group membership. The engine chokes every exclude pad against every other one, so only the two
    // hats carry it.
    exclude: boolean
}

const find = (name: string): KitSample => {
    const sample = DrumKits.TR808.concat(DrumKits.TR909).find(entry => entry.name === name)
    return isDefined(sample) ? sample : panic(`Unknown sample '${name}'`)
}

export namespace AcidKit {
    export const Pads: ReadonlyArray<Pad> = [
        {note: 36, sample: find("TR-808 Bass Drum"), exclude: false},
        {note: 37, sample: find("909 Bassdrum"), exclude: false},
        {note: 38, sample: find("TR-808 Snare Drum"), exclude: false},
        {note: 39, sample: find("909 Clap"), exclude: false},
        {note: 40, sample: find("TR-808 Rim Shot"), exclude: false},
        {note: 41, sample: find("TR-808 Low Tom"), exclude: false},
        {note: 42, sample: find("909 Closed Hat"), exclude: true},
        {note: 43, sample: find("TR-808 Mid Tom"), exclude: false},
        {note: 44, sample: find("TR-808 Maracas"), exclude: false},
        {note: 45, sample: find("TR-808 Hi Tom"), exclude: false},
        {note: 46, sample: find("909 Open Hat"), exclude: true},
        {note: 47, sample: find("TR-808 Low Conga"), exclude: false},
        {note: 48, sample: find("TR-808 Mid Conga"), exclude: false},
        {note: 49, sample: find("909 Crash"), exclude: false},
        {note: 50, sample: find("TR-808 Cowbell"), exclude: false},
        {note: 51, sample: find("909 Ride"), exclude: false}
    ]

    export const labelOf = (note: byte): string =>
        Pads.find(pad => pad.note === note)?.sample.name ?? String(note)
}
